import {
    useMutation,
} from '@tanstack/react-query'

import {
    useDispatch,
} from 'react-redux'
import requests from 'app/requests/CQuote.requests'
import {
    useJWTToken,
} from 'app/Auth'

import {
    failedToLoadSaveForm,
    startToSaveForm,
} from 'app/shared-components/FormStatuses/store/formStatuses.slice'
import simpleFullResponseApi from 'app/services/simpleApi/simpleFullResponseApi'
import {
    BEErrorResponse,
} from 'app/types/request.types'
import {
    CQuoteRequestData,
} from './useCQuoteCreate'

export default ({
    onSuccess,
}: {
    onSuccess: (responseData: any, locationName: string) => void
}) => {
    const token = useJWTToken()
    const dispatch = useDispatch()

    return useMutation({
        mutationFn: (cQuote: CQuoteRequestData) => {
            dispatch(
                startToSaveForm({
                    id: 'Notification',
                    title: 'Please stand by while we’re preparing the C-Quote PDF.',
                }),
            )
            return simpleFullResponseApi({
                ...requests.generateDocument(cQuote),
                responseType: 'arraybuffer',
                token,
            })
        },
        onError: (err: BEErrorResponse) => {
            const enc = new TextDecoder('utf-8')

            const {
                response: {
                    data: errors,
                    status: statusCode,
                },
            } = err

            dispatch(
                failedToLoadSaveForm({
                    id: 'Notification',
                    errors: JSON.parse(enc.decode(errors)),
                    statusCode,
                }),
            )
        },
        onSuccess: (response, {
            locationName,
        }) => {
            onSuccess(response, locationName)
        },
    })
}
